import ListModule from '../list-module'
import ListState from '../list-state'
import ManufacturerModel from '../../entities/admin/manufacturer-model'
import Util from '../../../lib/util'

interface ManufacturerModelState extends ListState<ManufacturerModel> {
  editModel: ManufacturerModel;
}

class ManufacturerModelModule extends ListModule<ManufacturerModelState, any, ManufacturerModel> {
  // State inicial
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<ManufacturerModel>(),
    loading: false,
    editModel: new ManufacturerModel(),
    activeList: new Array<ManufacturerModel>(),
    path: 'manufacturer-models',
  }

  actions = Util.extend(true, this.base_actions, {
    // Uses the standard list actions and response format shared by the admin modules.
  });

  mutations = Util.extend(true, this.base_mutations, {
    // Uses the standard list mutations.
  });
}

const manufacturerModelModule = new ManufacturerModelModule();
export default manufacturerModelModule;
